var API_DOMAIN = "https://pavithracrackers.com/api";

export default API_DOMAIN;
